import { render, staticRenderFns } from "./deals.vue?vue&type=template&id=7bc5c0fc&"
import script from "./deals.vue?vue&type=script&lang=js&"
export * from "./deals.vue?vue&type=script&lang=js&"
import style0 from "./deals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports